/**
 * `<table class="kb-table">`, the handbook's only table.
 *
 * Two changes, and each one covers a hole the other leaves.
 *
 * The class goes through `HTMLAttributes` because a live table is drawn by
 * prosemirror-tables' own node view, and a node view never calls `renderHTML`.
 * Setting it only in `renderHTML` gave a SAVED table the class and left the one
 * on screen unstyled: the writer saw bare rows while the reader got the real
 * thing, which is the exact promise this editor exists to keep.
 *
 * `renderHTML` is still overridden, because the stock one writes a `<colgroup>`
 * with a `<col>` per column. Neither tag is in the handbook vocabulary, so the
 * server refuses the save outright - and the message names a tag nobody typed.
 *
 * `resizable: false` for the same reason: a guide is read at one width in one
 * app, and column handles would write inline widths into the body that the
 * reader ignores and the vocabulary would then have to allow.
 */
import { Table, TableCell, TableHeader, TableRow } from "@tiptap/extension-table";
import { mergeAttributes } from "@tiptap/core";

export const KbTable = Table.extend({
  renderHTML({ HTMLAttributes }) {
    return ["table", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), ["tbody", 0]];
  },
}).configure({ resizable: false, HTMLAttributes: { class: "kb-table" } });

export const KbTableRow = TableRow;
export const KbTableCell = TableCell;
export const KbTableHeader = TableHeader;
